﻿export default class FilterList {
    constructor() {
        this.registerHandlebarsHelpers();
        this.initializeProperties();
        this.queryObject = this.loadQueryStringAsQueryObject();
        this.queryArray = this.mapQueryStringObjectToArray(this.queryObject);

        this.filter(this.queryArray, true);
        this.setEventListeners();

        const source = $('#FilteredList').html();
        this.template = Handlebars.compile(source);
    }

    registerHandlebarsHelpers() {
        Handlebars.registerHelper({
            eq: (v1, v2) => v1 === v2,
            ne: (v1, v2) => v1 !== v2,
            lt: (v1, v2) => v1 < v2,
            gt: (v1, v2) => v1 > v2,
            lte: (v1, v2) => v1 <= v2,
            gte: (v1, v2) => v1 >= v2,
            and: (v1, v2) => v1 && v2,
            or: (v1, v2) => v1 || v2,
        });
    }

    initializeProperties() {
        this.$container = $('.FilterList');
        this.$filterForm = $('.FilteredList-filterForm');
        this.formMethode = 'post';
        this.formAction = '/umbraco/api/VacancyApi/GetVacanciesFromElasticPost';
        this.$paging = $('.FilteredList-paging');
    }

    setEventListeners() {
        $(document)
            .on('change', '.selectStyle select', this.onSelect.bind(this))
            .on('click', '.FilterList-reset .reset', this.onResetClick.bind(this))
            .on('click', '.pagination--doNavigate', this.onPagingNavigate.bind(this));
    }

    loadQueryStringAsQueryObject() {
        const search = location.search.substring(1);
        return search
            ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', (key, value) =>
                  key === '' ? value : decodeURIComponent(value)
              )
            : {};
    }

    mapQueryStringObjectToArray(queryObject) {
        return Object.entries(queryObject).map(([key, value]) => ({
            name: key,
            value: value,
        }));
    }

    pushQueryToHistory() {
        const queryString = this.serializeQueryObject(this.buildQueryObjectFromForm());
        history.pushState(null, null, '?' + queryString + window.location.hash);
    }

    serializeQueryObject(obj) {
        return Object.entries(obj)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');
    }

    buildQueryObjectFromForm(_exclude = []) {
        const queryObject = {};

        $('.FilteredList-requestFilter').each((_, elm) => {
            const $filter = $(elm);
            queryObject[$filter.attr('name')] = $filter.val();
        });

        $('.filterList-filters select').each((_, select) => {
            const $select = $(select);
            const name = $select.attr('name');
            queryObject[name] = queryObject[name] || [];

            $select.find('option:selected').each((_, option) => {
                const $option = $(option);
                if ($option.val() !== '') {
                    queryObject[name].push($option.val());
                }
            });

            if (queryObject[name].length === 1) {
                queryObject[name] = queryObject[name][0];
            }
        });

        return queryObject;
    }

    scrollToResultList() {
        const resultListElement = document.querySelector('.ResultList');
        if (resultListElement) {
            resultListElement.scrollIntoView({ behavior: 'smooth' });
        }
    }

    filter(data, useQueryString = false) {
        const requestPayload = useQueryString
            ? this.buildRequestPayloadFromQueryArray(data)
            : this.buildRequestPayload(data.Limit, data.Offset);

        this.scrollToResultList();

        $.ajax({
            url: this.formAction,
            type: this.formMethode,
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(requestPayload),
            success: this.onFiltered.bind(this),
        });
    }

    buildRequestPayloadFromQueryArray(queryArray) {
        const requestPayload = {
            Limit: parseInt(queryArray.find((item) => item.name === 'limit')?.value) || 12,
            Offset: parseInt(queryArray.find((item) => item.name === 'offset')?.value) || 0,
            OrderItems: [{ Key: 'EndDateVacature', Direction: 'desc' }],
            FilterItems: queryArray
                .filter((item) => item.name !== 'limit' && item.name !== 'offset' && item.value)
                .map((item) => ({
                    Key: item.name,
                    Values: [item.value],
                    Operator: 'In',
                })),
            Text: '',
        };

        const filterMap = new Map();

        queryArray.forEach(({ name, value }) => {
            if (name === 'limit') {
                requestPayload.Limit = parseInt(value);
            } else if (name === 'offset') {
                requestPayload.Offset = parseInt(value);
            } else if (!filterMap.has(name)) {
                filterMap.set(name, {
                    Key: name,
                    Values: [value],
                    Operator: 'In',
                });
            }
        });

        requestPayload.FilterItems = Array.from(filterMap.values());

        return requestPayload;
    }

    buildRequestPayload(limit = 12, offset = 0) {
        const filterItems = [];

        $('.filterList-filters select').each((_, select) => {
            const $select = $(select);
            const selectedValue = $select.val();
            if (selectedValue) {
                filterItems.push({
                    Key: $select.attr('name'),
                    Values: [selectedValue],
                    Operator: 'In',
                });
            }
        });

        return {
            Limit: limit,
            Offset: offset,
            OrderItems: [{ Key: 'EndDateVacature', Direction: 'desc' }],
            FilterItems: filterItems,
            Text: '',
        };
    }

    onFiltered(data) {
        this.render(data);
        this.pushQueryToHistory();
    }

    render(data) {
        const html = this.template(this.mapViewData(data));
        this.$container.html(html);
    }

    mapViewData(data) {
        const totalItems = data.QueryCount;
        const totalPages = Math.ceil(totalItems / data.Limit);
        const page = data.page || Math.floor(data.Offset / data.Limit) + 1;

        const pages = Array.from({ length: totalPages }, (_, i) => ({
            index: i + 1,
            isCurrentPage: page === i + 1,
        }));

        const paging = {
            nextPage: page + 1,
            prevPage: page - 1,
            prevPageHigherOrOne: page - 1 >= 1,
            nextPageLowerOrEquel: page + 1 <= totalPages,
            allPages: pages,
            showPager: totalPages > 1,
        };

        const textfields = this.getTextFields();

        const jobLevelOrder = ['VMBO', 'MBO', 'HBO', 'WO'];

        data.Facets.forEach((facet) => {
            if (facet.Alias === 'jobLevel' && Array.isArray(facet.Options)) {
                facet.Options.sort((a, b) => {
                    return jobLevelOrder.indexOf(a.ValueAlias) - jobLevelOrder.indexOf(b.ValueAlias);
                });
            }
            facet.Icon = this.getIconMapping(facet.Alias);
            facet.Text = this.getFilterOptionText(facet.Title, textfields);
        });

        return {
            formAction: this.formAction,
            formMethode: this.formMethode,
            response: data,
            requestData: {
                page,
                offset: (page - 1) * data.Limit,
                limit: data.Limit,
            },
            paging,
            textfields,
        };
    }

    getTextFields() {
        return {
            resultsText: this.$container.data('resultstext'),
            filterlijstText: this.$container.data('filterlijsttext'),
            resetBtnText: this.$container.data('resetbtntext'),
            pagingFirstText: this.$container.data('pagingfirsttext'),
            pagingPrevText: this.$container.data('pagingprevtext'),
            pagingNextText: this.$container.data('pagingnexttext'),
            pagingLastText: this.$container.data('paginglasttext'),
            positionTypeText: this.$container.data('positiontypetext'),
            areaOfInterestText: this.$container.data('areaofinteresttext'),
            jobLevelText: this.$container.data('jobleveltext'),
        };
    }

    getIconMapping(alias) {
        const iconMappings = {
            positionType: 'fa-solid fa-briefcase',
            areaOfInterest: 'fa-solid fa-location-dot',
            jobLevel: 'fa-solid fa-graduation-cap',
        };
        return iconMappings[alias] || 'fa-solid fa-check';
    }

    getFilterOptionText(alias, textfields) {
        const filterOptionText = {
            positionType: textfields.positionTypeText,
            areaOfInterest: textfields.areaOfInterestText,
            jobLevel: textfields.jobLevelText,
        };
        return filterOptionText[alias] || '';
    }

    onPagingNavigate(event) {
        event.preventDefault();

        const $target = $(event.target).closest('.pagination--doNavigate');
        const val = parseInt($target.data('fieldvalue'), 10);
        const input = $target.data('field');
        const limit = 12;

        const offset = (val - 1) * limit;

        $(`input[name=${input}]`).val(val).attr('value', val);

        this.scrollToResultList();

        const requestPayload = this.buildRequestPayload(limit, offset);
        this.filter(requestPayload);
    }

    onSelect(event) {
        event.preventDefault();

        const $target = $(event.target).closest('.selectStyle');
        const $selectlist = $target.find('> select');
        const selectedValue = $selectlist.val();

        const data = this.buildRequestPayload();

        data.FilterItems.push({
            Key: $selectlist.attr('name'),
            Values: [selectedValue],
            Operator: 'In',
        });

        this.filter(data);
        this.pushQueryToHistory();
    }

    onResetClick(event) {
        event.preventDefault();

        $('.FilteredList-filterForm')
            .find('input, select')
            .each((_, element) => {
                const $element = $(element);
                if ($element.is('select') || $element.is('input[type="text"], input[type="hidden"]')) {
                    $element.val('');
                }
            });

        this.queryObject = {};
        this.queryArray = [];

        const defaultPayload = this.buildRequestPayload(12, 0);
        this.filter(defaultPayload);

        this.scrollToResultList();
    }

    isUndefined(obj) {
        return typeof obj === 'undefined';
    }

    isDefined(obj) {
        return !this.isUndefined(obj);
    }

    hasValue(obj) {
        return obj != null && this.isDefined(obj) && obj !== '';
    }
}
